<template>
  <main class="page-main information-center">
    <section class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('informationCenter.head') }}</h3>
    </section>

    <tab
      v-if="$i18n.locale === 'ko'"
      ref="tab"
      :tab-list="tabList"
      class="tab-is-scroll"
    />
    <router-view />
  </main>
</template>

<script>
export default {
  components: {
    tab: () => import('@/components/base/Tab'),
  },
  data () {
    return {
      word: '',
      tabList: [
        { path: 'CustomerServiceCenter', name: 'informationCenter.customerServiceCenter.head' },
        { path: 'InformationCenterConsult', name: 'informationCenter.consult.head' },
        { path: 'InformationCenterReport', name: 'informationCenter.report.head' },
      ]
    }
  },
  watch: {
    '$route' () {
      this.changeTab()
    }
  },
  mounted () {
    this.$nextTick(this.init)
  },
  methods: {
    init () {
      this.changeTab()
    },
    changeTab () {
      if (this.$i18n.locale === 'ko') {
        setTimeout(() => {
          this.$refs.tab.$el.querySelector('.tab-scroll').scrollTo({
            left: this.$refs.tab.$el.querySelector('.tab-scroll .active').offsetLeft,
            behavior: 'smooth'
          })
        }, 10)
      }
    }
  }
}
</script>
